export const createTrucksFilterQuery = (searchText: any) => ({
    truck: `%${searchText}%`,
});